import { btn } from "@/components/Page";

const formatPickaxeEffect = (miningBonus) => {
  const oreRangeBonus = Math.round(Number(miningBonus || 0) * 8);
  const greatYieldBonus = (Number(miningBonus || 0) * 0.15).toFixed(2).replace(/\.00$/, "").replace(/(\.\d)0$/, "$1");
  return `+${oreRangeBonus}% ore range • +${greatYieldBonus}% great-yield chance`;
};

export const MiningToolPanel = ({ equippedTool, tools, busyToolId, onPurchase, onEquip, onRepair }) => {
  return (
    <section data-testid="mining-tool-panel" className="border border-amber-900/30 bg-zinc-950/80 p-4 rounded-sm space-y-4">
      <div>
        <h2 className="font-cinzel text-base text-amber-300 uppercase tracking-wide">Mining Tool</h2>
        <p className="text-xs text-zinc-500 mt-1">Tools only affect mining and never appear in combat equipment screens.</p>
      </div>

      {equippedTool && (
        <div data-testid="mining-equipped-tool" className="border border-amber-700/40 bg-amber-950/10 p-4 rounded-sm">
          <div className="flex items-center justify-between gap-3">
            <div>
              <div data-testid="mining-equipped-tool-name" className="font-cinzel text-lg text-zinc-100">{equippedTool.name}</div>
              <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mt-1">Bonus +{equippedTool.mining_bonus}</div>
              <div data-testid="mining-equipped-tool-effect" className="text-xs text-zinc-400 mt-2">{formatPickaxeEffect(equippedTool.mining_bonus)}</div>
            </div>
            <div data-testid="mining-equipped-tool-durability" className="text-right text-sm text-zinc-300">
              Durability {equippedTool.durability} / {equippedTool.max_durability}
            </div>
          </div>
        </div>
      )}

      <div className="grid lg:grid-cols-2 gap-4">
        {tools.map((tool) => {
          const actionBusy = busyToolId === tool.id;
          return (
            <article key={tool.id} data-testid={`mining-tool-card-${tool.id}`} className={`border rounded-sm p-4 ${tool.equipped ? "border-amber-600 bg-amber-950/10" : "border-zinc-800 bg-zinc-900/60"}`}>
              <div className="flex items-start justify-between gap-3">
                <div>
                  <div data-testid={`mining-tool-name-${tool.id}`} className="font-cinzel text-lg text-zinc-100">{tool.name}</div>
                  <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mt-1">Requires Mining {tool.required_level}</div>
                </div>
                <div data-testid={`mining-tool-bonus-${tool.id}`} className="text-xs text-amber-300">+{tool.mining_bonus}</div>
              </div>

              <div data-testid={`mining-tool-effect-${tool.id}`} className="mt-2 text-xs text-zinc-400">{formatPickaxeEffect(tool.mining_bonus)}</div>

              <div className="mt-4 space-y-1 text-xs text-zinc-400">
                <div data-testid={`mining-tool-owned-${tool.id}`}>Owned: <span className="text-zinc-100">{tool.owned ? "Yes" : "No"}</span></div>
                <div data-testid={`mining-tool-durability-${tool.id}`}>Durability: <span className="text-zinc-100">{tool.owned ? `${tool.durability} / ${tool.max_durability}` : "—"}</span></div>
                <div data-testid={`mining-tool-cost-${tool.id}`}>Gold cost: <span className="text-zinc-100">{tool.cost_gold.toLocaleString()}</span></div>
              </div>

              <div className="mt-4 flex flex-wrap gap-2">
                {!tool.owned ? (
                  <button data-testid={`mining-tool-purchase-${tool.id}`} onClick={() => onPurchase(tool.id)} disabled={tool.locked || actionBusy} className={btn() + " flex-1 justify-center"}>
                    {tool.locked ? `Unlock at ${tool.required_level}` : (actionBusy ? "Purchasing" : "Purchase")}
                  </button>
                ) : tool.equipped ? (
                  <button data-testid={`mining-tool-equipped-${tool.id}`} type="button" disabled className={btn("ghost") + " flex-1 justify-center"}>Equipped</button>
                ) : (
                  <button data-testid={`mining-tool-equip-${tool.id}`} onClick={() => onEquip(tool.id)} disabled={!tool.usable || actionBusy} className={btn("ghost") + " flex-1 justify-center"}>
                    {actionBusy ? "Equipping" : (tool.usable ? "Equip" : "Repair first")}
                  </button>
                )}

                {tool.owned && tool.durability < tool.max_durability && (
                  <div className="flex flex-1 flex-col gap-2">
                    <button data-testid={`mining-tool-repair-${tool.id}`} onClick={() => onRepair(tool.id, "gold")} disabled={actionBusy} className={btn() + " w-full justify-center"}>
                      {actionBusy ? "Repairing" : `Repair (${tool.repair_cost_current.toLocaleString()} gold)`}
                    </button>
                    <button data-testid={`mining-tool-repair-follis-${tool.id}`} onClick={() => onRepair(tool.id, "follis")} disabled={actionBusy} className={btn("ghost") + " w-full justify-center"}>
                      {actionBusy ? "Repairing" : `Repair with Follis (${tool.repair_follis_cost_current.toLocaleString()} follis)`}
                    </button>
                  </div>
                )}
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};